export enum OperationTypes {
  Default = 'default',
  School = 'school',
  NEMT = 'NEMT',
  Microtransit = 'microtransit',
  AirportShuttle = 'airportShuttle',
  Employee = 'employee',
  Deliveries = 'deliveries',
  EVs = 'evs',
  Broker = 'broker',
}
